import { Box, Typography, Autocomplete, TextField, type AutocompleteProps } from '@mui/material';
import { osirisTokens } from '@/theme/tokens';

interface AutocompleteStandardProps<
  Value,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
> extends Omit<AutocompleteProps<Value, Multiple, DisableClearable, FreeSolo>, 'renderInput'> {
  label: string;
  placeholder?: string;
  renderInput?: AutocompleteProps<Value, Multiple, DisableClearable, FreeSolo>['renderInput'];
  textFieldSx?: object;
  error?: boolean;
  helperText?: string;
}

export function AutocompleteStandard<
  Value,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>({
  label,
  placeholder,
  renderInput,
  textFieldSx,
  error,
  helperText,
  ...props
}: AutocompleteStandardProps<Value, Multiple, DisableClearable, FreeSolo>) {
  return (
    <Box>
      {/* Figma control labels (28398:3897): txt-muted 13px, same as InputTextField */}
      <Typography variant="body2" sx={{ mb: '5px', fontSize: 13, color: osirisTokens.text.muted }}>
        {label}
      </Typography>
      <Autocomplete
        {...props}
        renderInput={
          renderInput ??
          ((params) => (
            <TextField
              {...params}
              placeholder={placeholder}
              error={error}
              helperText={helperText}
              sx={{
                '& input': { fontSize: '13px' },
                ...textFieldSx,
              }}
            />
          ))
        }
      />
    </Box>
  );
}
